import React from "react";
import SubcontractorPlaceholder from "@/pages/SubcontractorPlaceholder";
import { ChartBar } from "@phosphor-icons/react";

export default function SubReports() {
  return (
    <SubcontractorPlaceholder
      title="Taşeron Raporları"
      icon={ChartBar}
      description="Taşeron bazlı iş hacmi, karlılık ve dönem karşılaştırma raporları."
    />
  );
}
